import {dqs, noop} from './util'

const SPINNER = `
<!-- spinner -->
<div class="spinner lds-ripple mx-auto"><div></div><div></div></div>
`

const get_nodes = selectors => selectors
  .map(selector => dqs(selector) || [])
  .map(nodes => [nodes].flat())
  .flat()

export const get_modal = (
  message, button_label = null, button_aria_label, type = null, on_dismiss = noop
) => {
  /*
  const modal_header = !title ? '' : `
  <div class="modal-header">
    <h5 class="modal-title">${title}</h5>
  </div>
  `
  */

  if(!message) {
    throw new Error('get_modal: message is required')
  }

  const modal_header = ''
  const alert_css_classes = type !== null ? `alert-${type}` : ''
  const button_css_classes = type !== null ? `btn-${type}` : ''
  const modal_footer = !button_label ? '' : `
  <div class="modal-footer ${alert_css_classes} border-top-0">
    <button type="button" aria-label="${button_aria_label}" class="btn btn-lg ${button_css_classes} float-right">
    ${button_label}
    </button>
  </div>
  `
  const alert_aria_label = type === 'danger' ? 'Error' : ''

  return `
  <div class="modal-dialog">
    <div role="alertdialog" aria-label="${alert_aria_label}" aria-describedby="modal_message" aria-modal="true" tabindex="0" class="modal-content">
      ${modal_header}
      <div id="modal_message" class="modal-body h4 mb-0 ${alert_css_classes}">${message}</div>
      ${modal_footer}
    </div>
  </div>
  `
}

export const get_modal_with_buttons = (
  message, type = null, buttons
) => {
  if(!message) {
    throw new Error('get_modal: message is required')
  }

  const alert_css_classes = type !== null ? `alert-${type}` : ''
  const button_css_classes = type !== null ? `btn btn-lg btn-${type} float-right` : ''
  const button_list = buttons.map(({id, label}) => `
    <button id="${id}" type="button" class="${button_css_classes}">${label}</button>
  `)

  const modal_footer = `
  <div class="modal-footer ${alert_css_classes} border-top-0">
    ${button_list.join('\n')}
  </div>
  `

  return `
  <div class="modal-dialog">
    <div role="alertdialog" aria-label="Confirm" aria-describedby="modal_confirm" aria-modal="true" tabindex="0" class="modal-content">
      <div id="modal_confirm" class="modal-body h4 mb-0 ${alert_css_classes}">${message}</div>
      ${modal_footer}
    </div>
  </div>
  `
}

export const hide = (...selectors) => {
  for(const node of get_nodes(selectors)) {
    node.classList.add('d-none')
  }
}

export const show = (...selectors) => {
  for(const node of get_nodes(selectors)) {
    node.classList.remove('d-none')
  }
}

export const loading = (action, message) => {
  const notifications = dqs('#notifications')

  if(action === 'show') {
    const modal_message = `
    <div class="mb-3">${message}</div>
    ${SPINNER}
    `
    notifications.innerHTML = get_modal(modal_message)
    notifications.classList.remove('d-none')
    notifications.classList.add('d-flex')
  }

  if(action === 'hide') {
    notifications.innerHTML = ''
    notifications.classList.remove('d-flex')
    notifications.classList.add('d-none')
  }
}
